module.exports = __webpack_public_path__ + "static/hero_background-b2bca1c9adb215c05657f2677322b7b6.png";